import React from 'react';

function Contact() {
  return (
    <div className="contact-container">
      <h1 className="contact-header">Contact Me</h1>
      <form className="contact-form">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" placeholder="Your Name" />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" placeholder="Your Email" />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" placeholder="Your Message"></textarea>
        </div>
        <button className="submit-button" type="submit">Submit</button>
      </form>
    </div>
  );
}

export default Contact;